<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.previousDamageQuestion'|translate}}</h3>
    </div>

    <div>
      <mat-slide-toggle formControlName="previousDamageExists" name="previousDamageExists" class="slider"
                        labelPosition="before">{{'createProposal.' + 'previousDamageExists'|translate}}</mat-slide-toggle>
    </div>

    <div *ngIf="formGroup.controls.previousDamageExists.value" class="d-flex flex-column">
      <ng-container formArrayName="previousDamages">
        <ng-container *ngFor="let previousDamage of formGroup.controls.previousDamages.controls; let i = index">

          <div [formGroup]="previousDamage">
            <hr class="w-100 line">

            <div class="d-flex justify-content-between">
              <h5> {{'createProposal.subtitlePreviousDamage'|translate}} {{i + 1}}</h5>
              <button *ngIf="formGroup.controls.previousDamages.length > 1" (click)="deleteForm(i)"
                      class="delete-button h-32"><img
                src="assets/img/form/trashbin.svg"
                alt=""></button>
            </div>
            <div class="d-flex justify-content-between field-container">
              <app-input-field [control]="previousDamage.controls.year" [label]="('createProposal.year'| translate) "
                               class="smaller-input">
                <mat-select formControlName="year" class="input">
                  <mat-option
                    *ngFor="let year of getYearList()" [value]="year">
                    {{year}}
                  </mat-option>
                </mat-select>
              </app-input-field>
              <app-input-field [control]="previousDamage.controls.type"
                               [label]="('createProposal.damageType' |translate)"
                               class="bigger-input">
                <input name="type" formControlName="type" class="input">
              </app-input-field>
            </div>
            <div class="d-flex">
              <app-input-field [control]="previousDamage.controls.amountPaid" class="w-100"
                               [label]="('createProposal.amountPaid'|translate)">
                <input name="currentYearAmountPaid" appNumberFormat
                       formControlName="amountPaid"
                       class="left-rounded input">
              </app-input-field>
              <app-input-field [control]="previousDamage.controls.currency">
                <mat-select formControlName="currency"
                            class="right-rounded input"
                            [value]="previousDamage.controls.currency" #singleSelect>
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="previousDamageSearchArray[i].filterCtrlCurrency"
                      ngDefaultControl></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of previousDamageSearchArray[i].filteredOptionsCurrency |async"
                              [value]="option">
                    {{option}}
                  </mat-option>

                </mat-select>
              </app-input-field>
            </div>
          </div>
        </ng-container>
        <div class="d-flex justify-content-start">
          <button *ngIf="formGroup.controls.previousDamages.length<maxNumber" id="addButton" class="mt-3 add-button"
                  (click)="addForm()">
            + {{'createProposal.addPreviousDamage'|translate}}</button>
        </div>
      </ng-container>
    </div>
    <div class="mt-3 d-flex flex-column">
      <span
        class="small-title"> {{'proposalDetails.createOfferTab.fileUploadSection.title'|translate}}</span>
      <div class="d-flex field-container">
        <app-upload [uploadLocation]="UploadLocation.PREVIOUSDAMAGE"
                    (updateAttachedFilesInParent)="attachFiles($event)"
                    class="w-100"
        ></app-upload>
      </div>
    </div>
  </div>
</form>
